import React, { Component } from 'react';
import {ReactComponent as ArrowIcon} from '../start-here.svg';

class Buttons extends Component {
    constructor(props) {
        super(props);

       this.state = {
           sales: [],
           isactive: false,
           isactiveSettings: false,
           total: 0,
           cards: {},
           cardsCount: {},
           cardLimit: {},
           cardAmount: 0,
           lastclickedgroup: [],
           lastclicked: 0,
           activeTab: 'count',
           cardValues: [],
           warningMessage: '',
           openWarning: false,
           totalTakings: 0.00,
          }

        this.purchase = this.purchase.bind(this);
        this.displayTotal = this.displayTotal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.startNewDay = this.startNewDay.bind(this);
        this.undo = this.undo.bind(this);
        this.closeSettingsModal = this.closeSettingsModal.bind(this);
        this.openSettings = this.openSettings.bind(this);
        this.handNewDayClick = this.handNewDayClick.bind(this);
    }
    
    

    componentDidMount() {
        const localStoredState = JSON.parse(localStorage.getItem('state'));
        this.setState(localStoredState);
    }

    componentDidUpdate() {
      this.state.cardValues.map((card, index) => {
        if(card.limit === 0){
          return false;
        }
        if(card.count > card.limit) {
          const cardCopy = [...this.state.cardValues];
          cardCopy[index] = {
            ...card,
            'count': 0
          }
          return this.setState({cardValues: cardCopy})
        }
        return false;
      })
    }
    
    
    updateState = (newState) => {
        this.setState(newState, () => {
          localStorage.setItem('state', JSON.stringify(this.state));
        });
    }

    handleWarningMessage = () => {
      
    }
    
    updateCard(index, e, type){
      const cardsCopy = this.state.cardValues.length > 0 ? [...this.state.cardValues]: [];

      if(type === 'price') {
        cardsCopy[index].price = e.target.value;
      } else {
        cardsCopy[index].limit = e.target.value;
      }
  
    this.updateState({cardValues: cardsCopy})

    }

    displayTotal(){
        this.updateState ({isactive: true});
    }

    closeModal() {
        this.updateState ({isactive: false});
    }

    updateCountAndSetCards(e) {
      const cards = [];
      
      Array.from({length: e.target.value}, (_, index) => (
        cards.push({price: 0.00, title: index+1, count: 0, limit: 0, sold: 0})
      ));
      this.updateState({cardAmount: e.target.value, cardValues: cards})

    }

    closeSettingsModal(){
        this.updateState({isactiveSettings: false});
    }

    openSettings(){
      this.updateState({isactiveSettings: true});
    }

    calculateTotal() {
       let totalCardsSold = this.state.total;
       let totalValueSold = this.state.totalTakings;
       
       this.state.cardValues.forEach((card) => {
          totalValueSold = totalValueSold + (card.price * card.sold);
          totalCardsSold = totalCardsSold + card.sold;
      });

      return [totalValueSold, totalCardsSold];
    }

    startNewDay(){
      this.updateState({openWarning: false});
        const cardsCopy = this.state.cardValues;
        cardsCopy.map((card) => {
          return card.sold = 0;
        });

        this.updateState ({cardValues: cardsCopy, total: 0, totalTakings: 0, lastclickedgroup: []})
    }

    handNewDayClick() {
      this.updateState({openWarning: true, warningMessage: 'Are you sure you want to start a new day?'})
    }
  
    undo(){
      const cardsCopy = [...this.state.cardValues];
      if(this.state.lastclickedgroup.length === 0){
        return;
      }
      const lastClickedCopy = [...this.state.lastclickedgroup]
      const cardIndex =  lastClickedCopy.pop();
     
      cardsCopy[cardIndex] = {
        ...cardsCopy[cardIndex],
        count: cardsCopy[cardIndex].count - 1,
        sold: cardsCopy[cardIndex].sold - 1
      }
      
      this.updateState({cardValues: cardsCopy, lastclickedgroup: lastClickedCopy})
      
    }
  
  purchase(index){
    const cardsCopy = [...this.state.cardValues];
    cardsCopy[index] = {
      ...cardsCopy[index],
      sold: cardsCopy[index].sold + 1,
      count: cardsCopy[index].count + 1
    }
  
    const lastClickedGroup = this.state.lastclickedgroup.length > 0 ? [...this.state.lastclickedgroup, index]: [index];
    this.updateState({cardValues: cardsCopy, lastclickedgroup: lastClickedGroup});  
  }

  render(){
    const totalValues = this.calculateTotal();
   return (
    <div className="scratch-app">
    <div className="scratch-numbers">
        {this.state.cardValues.map((card, index) => (
                <div className="number" key={index} onClick={() => this.purchase(index)}>
                    <span>{card.title}</span>
                    <div className="card-count">
                    Card Count: {String(card.count).padStart(3, '0')}
                    </div>
                    <div className="card-price">
                    Card Price: {card.price}
                    </div>
                    <div className="indiv-total">
                      Total Sold: {card.sold}
                    </div>
                </div>
          ))}
    {this.state.cardValues.length === 0 && (
      <div className="instructions">
      To get started click "Settings"
      <ArrowIcon/>
    </div>
    )}      
    
    </div>

    

    <div className="buttons">
    <button className="undo" onClick={this.undo}>Undo</button>
    <button className="new_day" onClick={this.handNewDayClick}>Start New Day</button>
    <button className="total" onClick={this.displayTotal}>Daily Total</button>
    <button className="settings" onClick={this.openSettings}>Settings</button>
    </div>

    <div className={`modal-outer ${this.state.isactive ? 'open' : ''}`}>
    <div className="modal-inner">
        <button href="#" onClick={this.closeModal} className="close">&times;</button>
        <div className="text-outer">
            <div className="pop-text">Todays takings are £{totalValues[0]}</div>
            <div className="quantity-sold">You have sold {totalValues[1]} scratch cards today</div>
        </div>
    </div>
    </div>

    <div className={`modal-settings ${this.state.isactiveSettings ? 'open' : ''}`}>
        <button href="#" onClick={this.closeSettingsModal} className="close">&times;</button>
        <div className="text-outer">
          <div className="setting-panel-controls">
            <button className={`${this.state.activeTab === 'count' ? 'active' : ''} `} onClick={() => this.setState({activeTab: 'count'})}>Card Count</button>
            <button className={`${this.state.activeTab === 'price' ? 'active' : ''} `} onClick={() => this.setState({activeTab: 'price'})}>Card Prices</button>
            <button className={`${this.state.activeTab === 'limit' ? 'active' : ''} `} onClick={() => this.setState({activeTab: 'limit'})}>Card Limits</button>
          </div>
          <div className="setting-panels">
            <div className={`card-count-panel ${this.state.activeTab === 'count' ? 'active' : ''} `}>
            <span>
              How many scratch cards do you have?
              <input type="number" id="quantity" name="quantity" min="1" max="100" value={this.state.cardAmount} onChange={(e) => this.updateCountAndSetCards(e)} />
              </span>
              <p className="count-warning">Warning: If you update this value everything will reset.</p>
              
            </div>
            <div className={`card-price-panel ${this.state.activeTab === 'price' ? 'active' : ''} `}>
               {this.state.cardValues.map((card, index) => (
                  <div className="price-input" key={index}>
                  {`Card ${card.title} Price`}
                    <input type="number" inputmode="numeric" key={index} id={`card-price-${index}`} name={`card-price-${index}`} min="1.00" max="100.00" value={this.state.cardValues[index]?.price} onChange={(e) => this.updateCard(index, e, 'price')} />
                  </div>
               ))}
            </div>
            <div className={`card-limit-panel ${this.state.activeTab === 'limit' ? 'active' : ''}`}>
            {this.state.cardValues.map((card, index) => (
                  <div className="limit-input" key={index}>
                  {`Card ${card.title} Limit`}
                    <input type="number" inputmode="numeric" key={index} id={`card-limit-${index}`} name={`card-limit-${index}`} min="0" max="100" value={this.state.cardValues[index]?.limit} onChange={(e) => this.updateCard(index, e, 'limit')} />
                  </div>
               ))}
               <p>If limit is 0 card will have no limit.</p>
            </div>
          </div>
          
        </div>

    </div>

    <div className={`warning-modal ${this.state.openWarning ? 'open': ''}`}> 
      <p>{this.state.warningMessage}</p>
      <button onClick={this.startNewDay}>Start New Day</button>
      <button className="cancel" onClick={() => this.updateState({openWarning: false})}>Cancel</button>
    </div>
    </div>   
  );
}
}


export default Buttons;

